// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2yywG","buttons":"SendReceipts_buttons__7bky3","email":"SendReceipts_email__3BZrt","bookApptTitle":"SendReceipts_bookApptTitle__1z7zM"};